import axios from "axios"
import { API_BI } from "@constants/conf"
import {
  handleBoardResult,
  handleChartResult,
  handleAreasResult,
} from "./helper"
import memoryStore from "../util/memoryStore"

// 创建axios实例
const request = axios.create({
  baseURL: API_BI,
})

export const getSharedBoard = async (id: string | number) => {
  try {
    const result = await request.get(`/v1/share/open/board/${id}`)
    return handleBoardResult(result)
  } catch (error) {
    console.log(`WAYZ: getBoard -> error`, error)
  }
}

export const getSharedChart = async (
  id: string,
  dataCountLimit?: number,
  isLatestGeo?: boolean
) => {
  let key = id
  let url = `/v1/share/open/chart/${id}`
  if (dataCountLimit) {
    key += dataCountLimit
  }
  if (isLatestGeo) {
    key += isLatestGeo
  }
  try {
    let data = memoryStore.getItem(key)
    if (data) {
      return data
    }
    const result = await request.get(url, {
      params: { data_count_limit: dataCountLimit, is_latest_geo: isLatestGeo },
    })
    data = handleChartResult(result)
    memoryStore.setItem(key, data)
    return data
  } catch (error) {}
}

export const getAllAreaPolygon = async () => {
  try {
    let url = "/v1/areas"
    const result = await request.get(url, {
      params: { has_polygon: true },
    })
    return handleAreasResult(result)
  } catch (error) {
    return { tree: [], map: {} }
  }
}
